import Vue from "vue";
import Vuex from "vuex";
import applicationStore from "./application/store";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
    modules: {
        applicationStore        
    },
    strict: debug
});